import React from 'react';
import styled from 'astroturf/react';

import { Input } from 'js/design_system/forms/Input';

import { DateDraft } from './formState';

const Row = styled.div`
  @import 'stylesheets/design_system/breakpoint';

  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs-16, 16px);
  width: 100%;

  @include breakpoint(medium, large) {
    flex-direction: row;
  }

  & > * {
    flex: 1;
  }
`;

type DateFieldsProps = {
  label: string;
  required: boolean;
  value: DateDraft;
  onChange: (value: DateDraft) => void;
};

export function DateFields({
  label,
  required,
  value,
  onChange,
}: DateFieldsProps): React.ReactElement {
  const suffix = required ? ' *' : '';
  return (
    <Row>
      <Input
        label={`${label} year${suffix}`}
        value={value.year}
        inputMode="numeric"
        autoComplete="off"
        onChange={(event) => onChange({ ...value, year: event.target.value })}
      />
      <Input
        label="Month"
        value={value.month}
        inputMode="numeric"
        placeholder="1–12"
        autoComplete="off"
        onChange={(event) => onChange({ ...value, month: event.target.value })}
      />
      <Input
        label="Day"
        value={value.day}
        inputMode="numeric"
        placeholder="1–31"
        autoComplete="off"
        onChange={(event) => onChange({ ...value, day: event.target.value })}
      />
    </Row>
  );
}
